<template>
    <div class="ProviderAppointmentBlockDetail container-fluid">
        <div class="row">
            <div class="col-lg-3">
                <form @submit="SaveChanges">
                    <div class="form-group">
                        <label>Provider:</label>
                        <select v-model="RecordData.EmployeeID" class="form-control" required>
                            <option value="34eb04af-7980-4014-81bb-08dc711b7ad8">Dr. Garcia</option>
                            <option value="2654b90a-ed3f-41e4-e1b8-08dbbb82c673">Dr. Mand</option>
                            <option value="30a0f2f0-6d50-44a3-3598-08d95cdc4393">Dr. Patel</option>
                            <option value="309021d5-c963-41e4-4548-08db088014df">Dr. Ramsinghani</option>
                            <option value="af466de9-b7f6-4a0f-7a30-08dcd992a0fb">Dr. Siragusa</option>
                            <option value="9820b9c3-bc79-4b40-359a-08d95cdc4393">Dr. Cooper (Inactive)</option>
                            <option value="506b228c-a44c-4b44-066e-08da70bcad63">Dr. Tom (Inactive)</option>
                            <option value="c87c6161-8fe4-4f80-066f-08da70bcad63">Dr. Shin (Inactive)</option>
                            <option value="6fea255d-21c3-4bca-1a10-08db686a098e">Dr. Clarey (Inactive)</option>
                            <option value="cef74e5b-5ece-495d-1a11-08db686a098e">Dr. Lee (Inactive)</option>
                            <option value="1034e92c-f3a7-4275-a2fa-08db8df9df73">Dr. Feinstein (Inactive)</option>

                        </select>
                    </div>
                    <div class="form-group">
                        <label>Office Location:</label>
                        <select v-model="RecordData.OfficeLocation" class="form-control" required>
                            <option value="Riverside 525 Office">Riverside 525 Office</option>
                            <option value="Perris Office">Perris Office</option>
                            <option value="Palm Desert Wraparound Office">Palm Desert Wraparound Office</option>
                            <option value="Palm Desert Outpatient Clinic">Palm Desert Outpatient Clinic</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Provider's' Location:</label>
                        <select v-model="RecordData.ProviderLocation" class="form-control" required>
                            <option value="In Office">In Office</option>
                            <option value="Virtual">Virtual</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Time Block Starts:</label>
                        <flat-pickr v-model="RecordData.StartDateTime" class="form-control" :config="DateTimeConfig" required></flat-pickr>
                    </div>
                    <div class="form-group">
                        <label>Time Block Ends:</label>
                        <flat-pickr v-model="RecordData.EndDateTime" class="form-control" :config="DateTimeConfig" required></flat-pickr>
                    </div>
                    <button type="submit" class="form-control btn btn-success">SAVE TIME BLOCK</button>
                    <button v-if="RecordData.Id" type="button" @click="NewBreak()" class="form-control btn btn-primary" style="margin-top:25px;">ADD BREAK</button>
                    <button v-if="RecordData.Id" type="button" @click="Delete()" class="form-control btn btn-danger" style="margin-top:25px;">DELETE TIME BLOCK</button>
                </form>
            </div>
            <div class="col-lg-9">
                <div v-show="RecordData.Id">
                    <div class="row">
                        <div class="col-md-3">
                            <i class="fa fa-square" style="color: #94A545;" /> Confirmed
                        </div>
                        <div class="col-md-3">
                            <i class="fa fa-square" style="color: #007bff;" /> Booked
                        </div>
                        <div class="col-md-3">
                            <i class="fa fa-square" style="color: #808080;" /> Tentative
                        </div>
                        <div class="col-md-3">
                            <i class="fa fa-square" style="color: #A30000;" /> Cancelled
                        </div>
                        <div class="col-md-3">
                            <i class="fa fa-square" style="color: #94A545;" /> Occurred
                        </div>
                    </div>
                    <FullCalendar ref="calendar" :options="CalendarOptions" />

                </div>
            </div>
        </div>

        <!--SESSION EDIT MODAL-->
        <b-modal ref="session-modal" title="SESSION DETAILS" hide-footer size="lg">
            <b-container>
                <b-form @submit="SaveSession">
                    <b-row>
                        <b-col>
                            <h3>Appointment Info</h3>
                            <div v-if="!TargetSession.Id">
                                <div class="form-group">
                                    <label>Program:</label>
                                    <select v-model="TargetSession.SubProgramID" class="form-control" @change="GetAvailableClients">
                                        <option value="12E83DA9-E178-4DB2-9077-6097F277443A">Wraparound</option>
                                        <option value="41870532-AB7A-445B-A690-733150960EBF">Residential</option>
                                        <option value="28CD87C1-85B2-4B3B-B348-8ED0688B7F15">Outpatient</option>
                                        <option value="CBC3D45D-E45C-4BD5-887F-5AB87F154038">Mid County Outpatient</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Client:</label>
                                    <v-select required :options="AvailableClients" label="text" :reduce="option => option.value" v-model="TargetSession.ClientSubProgramMembershipID">
                                        <template #search="{attributes, events}">
                                            <input class="vs__search"
                                                   :required="!TargetSession.ClientSubProgramMembershipID"
                                                   v-bind="attributes"
                                                   v-on="events" />
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                            <div v-else>
                                <div class="form-group">
                                    <label>Client:</label>
                                    <input type="hidden" v-model="TargetSession.ClientSubProgramMembershipID" />
                                    <p class="bold">{{TargetSession.ClientSubProgramMembership.Client.Person.FullName}}</p>
                                </div>
                            </div>

                            <div class="form-group">
                                <label>Appointment Type:</label>
                                <select v-model="TargetSession.AppointmentType" class="form-control" required>
                                    <option value="Follow-Up">Follow-Up</option>
                                    <option value="Assessment">Assessment</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Client Location:</label>
                                <select v-model="TargetSession.ClientLocation" class="form-control" required>
                                    <option value="Client in Office">Client in Office</option>
                                    <option value="Client at Home">Client at Home</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Appointment Starts:</label>
                                <flat-pickr v-model="TargetSession.StartDateTime" class="form-control" :config="DateTimeConfig" required></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Appointment Ends:</label>
                                <flat-pickr v-model="TargetSession.EndDateTime" class="form-control" :config="DateTimeConfig" required></flat-pickr>
                            </div>
                            <div v-if="!TargetSession.Id && TargetSession.ClientSubProgramMembershipID" class="form-group">
                                <label>Carry Forward Last Appointment:</label>
                                <b-button @click="CarryForwardLastSessionData" size="md" variant="primary" type="button" class="form-control">
                                    CARRY FORWARD
                                </b-button>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Notes</h3>
                            <div class="form-group">
                                <label>Appointment Status:</label>
                                <select v-model="TargetSession.AppointmentStatus" class="form-control" required>
                                    <option value="Tentative">Tentative</option>
                                    <option value="Booked">Booked</option>
                                    <option value="Confirmed">Confirmed</option>
                                    <option value="Cancelled">Cancelled</option>
                                    <option value="Occurred">Occurred</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Caregiver Name(s):</label>
                                <textarea v-model="TargetSession.CaregiverNames" class="form-control" rows="5" />
                            </div>
                            <div class="form-group">
                                <label>Caregiver Phone:</label>
                                <textarea v-model="TargetSession.CaregiverPhone" class="form-control" rows="5" />
                            </div>
                            <div class="form-group">
                                <label>Pharmacy Info:</label>
                                <textarea v-model="TargetSession.PharmacyInfo" class="form-control" rows="5" />
                            </div>
                            <div class="form-group">
                                <label>JV-220:</label>
                                <textarea v-model="TargetSession.JV220Notes" class="form-control" rows="5" />
                            </div>
                            <div class="form-group">
                                <label>Labs:</label>
                                <textarea v-model="TargetSession.LabsNotes" class="form-control" rows="5" />
                            </div>
                            <div class="form-group">
                                <label>Physical:</label>
                                <textarea v-model="TargetSession.PhysicalNotes" class="form-control" rows="5" />
                            </div>
                            <div class="form-group">
                                <label>Staff on Call:</label>
                                <textarea v-model="TargetSession.StaffOnCall" class="form-control" rows="5" />
                            </div>
                            <div class="form-group">
                                <label>Cancellation Notes (if applicable):</label>
                                <textarea v-model="TargetSession.CancellationReason" class="form-control" rows="5" />
                            </div>
                            <div class="form-group">
                                <label>Misc:</label>
                                <textarea v-model="TargetSession.MiscNotes" class="form-control" rows="5" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelShowSession()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                            <b-button v-if="TargetSession.Id" size="md" variant="danger" type="button" @click="DeleteSession()">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <!--BREAK EDIT MODAL-->
        <b-modal ref="break-modal" title="BREAK DETAILS" hide-footer size="md">
            <b-container>
                <b-form @submit="SaveBreak">
                    <b-row>
                        <b-col>
                            <h3>Break Info</h3>
                            <div class="form-group">
                                <label>Break Starts:</label>
                                <flat-pickr v-model="TargetBreak.StartDateTime" class="form-control" :config="DateTimeConfig" required></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Break Ends:</label>
                                <flat-pickr v-model="TargetBreak.EndDateTime" class="form-control" :config="DateTimeConfig" required></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelShowBreak()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                            <b-button v-if="TargetBreak.Id" size="md" variant="danger" type="button" @click="DeleteBreak()">
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

    </div>
</template>

<script>
    
    import FullCalendar from '@fullcalendar/vue';
    import dayGridPlugin from '@fullcalendar/daygrid';
    import timeGridPlugin from '@fullcalendar/timegrid';
    import interactionPlugin from '@fullcalendar/interaction';

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    
    export default {
        name: "ProviderAppointmentBlockDetail",
        data: function () {
            return {
                RecordData: {
                    //StartDateTime: "2023-01-01T08:00:00",
                    //EndDateTime: "2023-01-01T19:00:00"
                },
                Records: [],
                AvailableClients: [],
                DateTimeConfig: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y h:i K',
                },
                TargetSession: {},
                TargetBreak: {}
            };
        },
        methods: {
            GetData() {
                
            },
            SetNew() {
                this.RecordData = {};
            },
            SaveChanges(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "MentalHealth/Appointments/ProviderAppointmentBlocks", this.RecordData, this.SaveChangesSuccess, () => { }, true);
                
            },
            SaveChangesSuccess(response) {
                this.RecordData = response.data.data;
                this.$parent.$parent.LoadData();
                this.$parent.$parent.HideBlockDetail();
            },
            ShowDetail(eventId) {
                this.RecordData = {};
                this.$MasterAPI.ExecuteRequest("GET", "MentalHealth/Appointments/ProviderAppointmentBlocks/" + eventId, {} , this.ShowDetailSuccess, () => { }, true);
            },
            ShowDetailSuccess(response) {
                this.RecordData = response.data.data;

                let calAPI = this.$refs['calendar'].getApi();
                calAPI.gotoDate(response.data.data.StartDateTime.substring(0, 10));
                this.$parent.$parent.ShowBlockDetail();
            },
            Delete() {
                this.$MasterAPI.ExecuteRequest("DELETE", "MentalHealth/Appointments/ProviderAppointmentBlocks/" + this.RecordData.Id, {}, this.DeleteSuccess, () => { }, true);

            },
            DeleteSuccess(response) {
                this.$parent.$parent.LoadData();
                this.$parent.$parent.HideBlockDetail();
            },
            //CAL HANDLERS
            HandleSelect: function (arg) {
                this.NewSession(arg.startStr, arg.endStr);
            },
            HandleEventClick(e) {
                if (e.event.extendedProps.functionalName == "Session") {
                    this.ShowSession(e);
                } else if (e.event.extendedProps.functionalName == "Break") {
                    this.ShowBreak(e);
                }
            },
            //SESSION
            NewSession(startObj, endObj) {
                this.TargetSession = {
                    StartDateTime: startObj,
                    EndDateTime: endObj,
                    ProviderAppointmentBlockID: this.RecordData.Id
                };
                this.$refs['session-modal'].show();
            },
            ShowSession(e) {
                this.$MasterAPI.ExecuteRequest("GET", "MentalHealth/Appointments/ProviderAppointmentSessions/" + e.event.id, {}, this.ShowSessionSuccess, () => { }, true);
            },
            ShowSessionSuccess(response) {
                this.TargetSession = response.data.data;
                this.$refs['session-modal'].show();
            },
            CancelShowSession() {
                this.$refs['session-modal'].hide();
            },
            SaveSession(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "MentalHealth/Appointments/ProviderAppointmentSessions", this.TargetSession, this.SaveSessionSuccess, () => { }, true);
            },
            SaveSessionSuccess(response) {
                let calAPI = this.$refs['calendar'].getApi();
                calAPI.refetchEvents();
                this.$parent.$parent.LoadData();
                this.$refs['session-modal'].hide();
            },
            DeleteSession() {
                this.$MasterAPI.ExecuteRequest("DELETE", "MentalHealth/Appointments/ProviderAppointmentSessions/" + this.TargetSession.Id, {}, this.DeleteSessionSuccess, () => { }, true);
            },
            DeleteSessionSuccess(response) {
                let calAPI = this.$refs['calendar'].getApi();
                this.$parent.$parent.LoadData();
                calAPI.refetchEvents();
                this.$refs['session-modal'].hide();
            },
            CarryForwardLastSessionData() {
                this.$MasterAPI.ExecuteRequest("GET", "MentalHealth/Appointments/ProviderAppointmentSessions/CarryForwardLastSessionData", { ClientSubProgramMembershipID: this.TargetSession.ClientSubProgramMembershipID }, this.CarryForwardLastSessionDataSuccess, () => { }, true);
            },
            CarryForwardLastSessionDataSuccess(response) {
                let data = response.data.data;
                this.TargetSession.CaregiverNames = data.CaregiverNames;
                this.TargetSession.CaregiverPhone = data.CaregiverPhone;
                this.TargetSession.PharmacyInfo = data.PharmacyInfo;
                this.TargetSession.JV220Notes = data.JV220Notes;
                this.TargetSession.LabsNotes = data.LabsNotes;
                this.TargetSession.PhysicalNotes = data.PhysicalNotes;
                this.TargetSession.MiscNotes = data.MiscNotes;
                this.TargetSession.StaffOnCall = data.StaffOnCall;
                this.TargetSession.ClientLocation = data.ClientLocation;
                this.$forceUpdate();
            },
            //BREAKS
            NewBreak() {
                this.TargetBreak = {
                    StartDateTime: null,
                    EndDateTime: null,
                    ProviderAppointmentBlockID: this.RecordData.Id
                };
                this.$refs['break-modal'].show();
            },
            ShowBreak(e) {
                this.TargetBreak = {
                    StartDateTime: e.event.start,
                    EndDateTime: e.event.end,
                    Id: 'can delete',
                    ProviderAppointmentBlockID: this.RecordData.Id
                };
                this.$refs['break-modal'].show();
            },
            CancelShowBreak() {
                this.$refs['break-modal'].hide();
            },
            SaveBreak(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("PATCH", "MentalHealth/Appointments/ProviderAppointmentSessions/Breaks/Add", this.TargetBreak, this.SaveBreakSuccess, () => { }, true);
            },
            SaveBreakSuccess(response) {
                let calAPI = this.$refs['calendar'].getApi();
                calAPI.refetchEvents();
                this.$parent.$parent.LoadData();
                this.$refs['break-modal'].hide();
            },
            DeleteBreak() {
                this.$MasterAPI.ExecuteRequest("PATCH", "MentalHealth/Appointments/ProviderAppointmentSessions/Breaks/Delete", this.TargetBreak, this.DeleteBreakSuccess, () => { }, true);
            },
            DeleteBreakSuccess(response) {
                let calAPI = this.$refs['calendar'].getApi();
                this.$parent.$parent.LoadData();
                calAPI.refetchEvents();
                this.$refs['break-modal'].hide();
            },
            //CLIENTS
            GetAvailableClients() {
                this.$MasterAPI.ExecuteRequest("GET", "MentalHealth/Appointments/ProviderAppointmentSessions/AvailableClients", { SubProgramID: this.TargetSession.SubProgramID }, this.GetAvailableClientsSuccess, () => { }, true);
            },
            GetAvailableClientsSuccess(response) {
                this.AvailableClients = response.data.data;
            },
            //CalendarOptions() {
            //    let vm = this;

            //    let initialOptions = {
            //        plugins: [timeGridPlugin, interactionPlugin, dayGridPlugin],
            //        initialView: "timeGridDay",
            //        //validRange: {
            //        //    start: this.RecordData.StartDateTime.substring(10),
            //        //    end: this.RecordData.StartDateTime.substring(10)
            //        //},
            //        editable: false,
            //        allDaySlot: false,
            //        slotMinTime: this.RecordData.Id ? this.RecordData.StartDateTime.substring(11) : '08:00:00',
            //        slotMaxTime: this.RecordData.Id ? this.RecordData.EndDateTime.substring(11) : '20:00:00',
            //        //contentHeight: 1200,
            //        height: 600,
            //        selectable: true,
            //        //allDaySlot: true,
            //        select: this.HandleSelect,
            //        eventClick: vm.HandleEventClick,
            //        //eventResize: this.HandleEventResize,
            //        //eventDrop: this.HandleEventDrop,
            //        //events: '/API/Wraparound/ClientAppointments/GetMyAppointments',
            //        eventSources: [
            //            {
            //                url: '/API/MentalHealth/Appointments/ProviderAppointmentSessions',
            //                extraParams: { ProviderAppointmentBlockID: this.RecordData.Id }
            //            }
            //        ],
            //        eventSourceSuccess: function (content, xhr) {
            //            vm.Records = content.data;
            //            return content.data;
            //        }
            //    };

            //    return initialOptions;

            //},
        },
        components: {
            FullCalendar,
            flatPickr,
            vSelect
        },
        mounted() {
            
        },
        computed: {
            CalendarOptions: function () {
                let vm = this;

                let initialOptions = {
                    plugins: [timeGridPlugin, interactionPlugin, dayGridPlugin],
                    initialView: "timeGridDay",
                    //validRange: {
                    //    start: this.RecordData.StartDateTime.substring(10),
                    //    end: this.RecordData.StartDateTime.substring(10)
                    //},
                    editable: false,
                    allDaySlot: false,
                    slotMinTime: this.RecordData.Id ? this.RecordData.StartDateTime.substring(11) : '08:00:00',
                    slotMaxTime: this.RecordData.Id ? this.RecordData.EndDateTime.substring(11) : '20:00:00',
                    //contentHeight: 1200,
                    height: 600,
                    selectable: true,
                    //allDaySlot: true,
                    select: this.HandleSelect,
                    eventClick: vm.HandleEventClick,
                    //eventResize: this.HandleEventResize,
                    //eventDrop: this.HandleEventDrop,
                    //events: '/API/Wraparound/ClientAppointments/GetMyAppointments',
                    eventSources: [
                        {
                            url: '/API/MentalHealth/Appointments/ProviderAppointmentSessions',
                            extraParams: { ProviderAppointmentBlockID: this.RecordData.Id }
                        }
                    ],
                    eventSourceSuccess: function (content, xhr) {
                        vm.Records = content.data;
                        return content.data;
                    }
                };

                return initialOptions;
                
            },
        }
    }
</script>

<style scoped>

</style>